/* eslint-disable */
// Billeder på Votra Business. To slags med vilje:
// - Fotografier, hvor motivet skal være ægte: værksted, papirbunken, motorvejen.
// - Billeder skabt specifikt til Votra i navy og guld, hvor motivet er abstrakt:
//   overblik, resultat pr. bil, dokumenter med frister. De findes ikke andre steder,
//   så siden ikke ender med at se ud som enhver anden skabelon.

export const BILLEDER = {
  vaerksted:
    "https://images.unsplash.com/photo-1655345391294-0fe2f61dff59?crop=entropy&cs=srgb&fm=jpg&q=85&fit=crop&w=1800&h=772",
  papirbunke:
    "https://images.unsplash.com/photo-1583521214690-73421a1829a9?crop=entropy&cs=srgb&fm=jpg&q=85&fit=crop&w=1800&h=772",
  motorvej:
    "https://images.unsplash.com/photo-1581010105267-67447703cfe9?crop=entropy&cs=srgb&fm=jpg&q=85&fit=crop&w=1800&h=772",
  overblik:
    "https://static.prod-images.emergentagent.com/jobs/ea6bea2b-10fa-4a24-af0c-baf6c4d03bbf/images/38c9a3a6335d2f7a8187e59d6522086492b7986fa4540093ef3493c2e8fa2fe4.jpeg",
  resultatPrBil:
    "https://static.prod-images.emergentagent.com/jobs/ea6bea2b-10fa-4a24-af0c-baf6c4d03bbf/images/888b78ba9fd42b2a065b2bb175d39a67a4889ba5833643aa43157dedc0fac91b.jpeg",
  dokumenter:
    "https://static.prod-images.emergentagent.com/jobs/ea6bea2b-10fa-4a24-af0c-baf6c4d03bbf/images/32eb49275280f26b317ce7451537caa7e4a884bb6e07e2c9a69a628eeeaf8bc7.jpeg",
};
